export default {
  'userAndCompany.newPasswordLabel': 'New Password',
  'userAndCompany.newPasswordConfirmationLabel': 'New Password Confirmation',
  'userAndCompany.userAndCompanyChangePassword': 'Change your password',
  'userAndCompany.userAndCompanyChangePasswordMessage':
    'Your password must have a minimum of 8 characters. It must also contains at least one uppercase character, one lowercase character and a number.',
  'userAndCompany.updateProfileInfosCompleted': 'Your profile informations has been updated successfully!',
  'userAndCompany.updateConnectionInfosCompleted': 'Your connection informations has been updated successfully!',
};
